const defaultObjAttributes = {
  title: "string",
  description: "string"
} as const

const defaultPageAttributes = {
  ...defaultObjAttributes,
  body: "widgetlist",
  navigationTitle: "string",
  showInNavigation: "boolean",
  keywords: "stringlist",
  isLoginRequired: "boolean",
  robotsIndex: "boolean",

  // Twitter attributes
  tcCreator: "string",
  tcDescription: "string",
  tcImage: ["reference", { only: ["Image"] }],
  tcTitle: "string",
  // Open Graph attributes (used by Facebook)
  ogDescription: "string",
  ogImage: ["reference", { only: ["Image"] }],
  ogTitle: "string",

  // The order of the child pages
  childOrder: "referencelist"
} as const

export { defaultObjAttributes, defaultPageAttributes }
